module.exports = __webpack_public_path__ + "img/overview.45ca4b1f.png";